import { IDragPanControl, IDragPanControlEventArgs } from "esdm-map/dist/map/controls/Interfaces/IDragPanControl";
import { SimpleEventDispatcher, ISimpleEvent } from "ste-simple-events";
import { IMap } from "esdm-map/dist/map/IMap";
import { IMappingTextPack } from "esdm-map/dist/resources/MappingTextPack";


import OLDragPan from "ol/interaction/DragPan";
import { MapBrowserEvent } from "ol";
import { Condition, noModifierKeys} from "ol/events/condition";

export class DragPanControlCL implements IDragPanControl {

    private _onDragPan = new SimpleEventDispatcher<IDragPanControlEventArgs>();
    public get onDragPan(): ISimpleEvent<IDragPanControlEventArgs> {
        return this._onDragPan.asEvent();
    }

    private interval = null;
    private _allowDragPan: boolean = true;
    private _dragPanOverLay: JQuery<HTMLElement>;
    private _hasTouch: boolean;

    public constructor(
        private _map: IMap,
        private _mappingTextPack: IMappingTextPack) {
        let self = this;

        self._hasTouch = ('ontouchstart' in window || navigator.maxTouchPoints > 0);

        let dragPanIndex = self._map.olMap.getInteractions().getArray().findIndex(function (element) {
            return element instanceof OLDragPan
        });

        if (dragPanIndex > -1 && self._hasTouch) {
            self.handleScroll(self._map);
            self._map.olMap.getInteractions().removeAt(dragPanIndex);
            self._map.olMap.getInteractions().insertAt(dragPanIndex, new OLDragPan({
                //cobbled together from here:
                //https://codepen.io/HansB1984/pen/OJLogga
                //https://github.com/openlayers/openlayers/issues/9936
                //https://github.com/openlayers/openlayers/issues/6767               

                condition: function (olBrowserEvent: MapBrowserEvent) {

                    console.log("DragPan.condition");

                    //if map is full screen just return true
                    if (document["fullscreenElement"]) {
                        return true;
                    }

                    //we can't use targetPointers.length directly because its an internal property and does not work with the minified version of openlayers
                    //so we go through the object properties lookign for Array< ol.pointer.PointerEvent>
                    let dpInteraction = this;
                    let targetPointers = null;
                    for (let prop in dpInteraction) {
                        if (dpInteraction[prop] instanceof Array) {
                            //ok its an array but is it an array of the correct sort (DOM PointerEvent)?
                            if (dpInteraction[prop][0] && dpInteraction[prop][0]["pointerType"] === "touch") {
                                targetPointers = dpInteraction[prop];

                                console.log("targetPointers:" + targetPointers.length);
                                console.log(dpInteraction[prop][0]["type"]);
                            }
                        }
                    }

                    if (self._hasTouch && targetPointers === null) {
                        self._hasTouch = false;
                        console.error("DragPan - targetPointers cannot be null");
                    }

                    //even when the user uses 2 fingers at once this function gets triggered twice and the first time the targetPointers.length === 1

                    //self._allowDragPan = ol.events.condition.noModifierKeys(olBrowserEvent) && (!self._hasTouch || targetPointers.length === 2);
                    self._allowDragPan = noModifierKeys(olBrowserEvent) && (!self._hasTouch || targetPointers.length === 2);

                    return self._allowDragPan;
                }
            })
            );
        }

        self.onDragPan.subscribe(this.handleDragPan);
    }

    protected handleScroll = (map: IMap): void => {
        let self = this;
        // the quick-changing holder of last touchmove y
        let lastTouchY = null;
        let handledNoPan: boolean = false;

        const div = document.getElementById(map.options.mapElementId)
        const scrollerBlades = document.scrollingElement || document.documentElement

        //add the touch handler to the viewport and not the map div as it stop scrolling in the side panel
        let viewport = div.getElementsByClassName("ol-viewport ol-touch")[0];

        if (viewport) {
            viewport.addEventListener('touchmove', function (e: TouchEvent) {
                e.preventDefault()

                const touches = e.touches || e.changedTouches

                if (!handledNoPan && !self._allowDragPan) {
                    //we only trigger the warning if there is an actual touchmove event                 
                    //problem is that an info click currently triggers the warning, so we only show the message if
                    //allowDragPan is false and we are in touchmoving and haven't shown the message since the last touchend
                    self.interval = window.setTimeout(function () {
                        //raise event so calling code can decide whether to notify the user
                        self._onDragPan.dispatch({
                            panAllowed: false
                        });
                    }, 200);

                    handledNoPan = true;
                }

                // on 1-finger-touchmove, scroll and take note of prev y
                if (touches.length === 1) {
                    if (lastTouchY !== null) {
                        const by = lastTouchY - touches[0].clientY
                        scrollerBlades.scrollTop += by
                    }
                    lastTouchY = touches[0].clientY
                }
            });

            // on touchend, reset y
            viewport.addEventListener('touchend', e => {
                handledNoPan = false;
                lastTouchY = null;
            });
        }

    }

    protected handleDragPan = (args: IDragPanControlEventArgs): void => {
        let self = this;

        if (!args.panAllowed && !self._dragPanOverLay) {
            let div: JQuery<HTMLElement> = $(`#${self._map.options.mapElementId}`).parent();
            self._dragPanOverLay = $(`<div class='twoFingersToMoveMap'><div>${self._mappingTextPack.twoFingersPan}</div></div>`);

            div.append(self._dragPanOverLay.hide().fadeIn(500));
            setTimeout(function () {
                self._dragPanOverLay.fadeOut(750, function () {
                    self._dragPanOverLay.remove();
                    self._dragPanOverLay = null;
                });
            }, 2500);
        }
    }
}

